import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("circle", {
        cx: "50",
        cy: "50",
        r: "50",
        opacity: ".1"
      }),
      _createElementVNode("path", {
        d: "M64.5 38.429H34.929a1.928 1.928 0 1 1 0-3.858h9.642A2.57 2.57 0 0 1 47.143 32h5.143a2.571 2.571 0 0 1 2.571 2.571H64.5a1.929 1.929 0 0 1 0 3.858Zm-1.929 24.428A5.143 5.143 0 0 1 57.43 68H42a5.142 5.142 0 0 1-5.143-5.143V41h25.714v21.857ZM47.143 48.071a1.929 1.929 0 0 0-3.857 0v11.572a1.929 1.929 0 0 0 3.857 0V48.07Zm9 0a1.929 1.929 0 0 0-3.857 0v11.572a1.929 1.929 0 0 0 3.857 0V48.07Z",
        opacity: ".9"
      })
    ], -1)
  ])))
}
export default { render: render }